import { render, staticRenderFns } from "./AppInputFile.vue?vue&type=template&id=1351b0f5&scoped=true&lang=pug&"
import script from "./AppInputFile.vue?vue&type=script&lang=js&"
export * from "./AppInputFile.vue?vue&type=script&lang=js&"
import style0 from "./AppInputFile.vue?vue&type=style&index=0&id=1351b0f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351b0f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1351b0f5')) {
      api.createRecord('1351b0f5', component.options)
    } else {
      api.reload('1351b0f5', component.options)
    }
    module.hot.accept("./AppInputFile.vue?vue&type=template&id=1351b0f5&scoped=true&lang=pug&", function () {
      api.rerender('1351b0f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppInputFile.vue"
export default component.exports